import { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import Navigator from 'src/components/Navigator';
import TaskDetails from "src/modules/data-protection/components/RisksAndTasks/tasks/details";
import { formatTaskAndRiskId } from "src/modules/data-protection/constants/Common";

const EmployeeTaskDetail = ({
    t,
    history,
    match: {
        params
    }
}) => {
    const [taskData, setTaskData] = useState(null);
    const taskTitle = taskData
        ? formatTaskAndRiskId(
            'task',
            taskData?.questionnaire === "software" ? taskData?.asset_id : taskData?.case_secondary_id,
            taskData?.risk_secondary_id ?? taskData?.secondary_id,
            taskData?.is_mitigation,
            taskData?.questionnaire,
            taskData?.secondary_id
        )
        : t('Task details');

    return (
        <div className='page-content'>
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator
                            pageTitle={taskTitle}
                            translate={false}
                            breadCrumbs={[
                                { title: 'SIP', link: '/employee/home?landing=false' },
                                { title: 'My Tasks', link: '/employee/data-protection/tasks' },
                                { title: 'Detail', link: '#' }
                            ]}
                            backButtonOptions={(defaults) => ({
                                ...defaults,
                                enable: true,
                                onClick: () => history.push('/employee/data-protection/tasks')
                            })}
                        />
                    </Col>
                </Row>

                <div className='bg-white p-4 mb-4'>
                    <TaskDetails
                        taskId={params?.id}
                        onTaskDataFetched={(data) => setTaskData(data)}
                        onBackClicked={() => {
                            history.push('/employee/data-protection/tasks')
                        }}
                        canUserEdit={false}
                        onRelatedTaskClicked={(id) => {
                            history.push(`/employee/data-protection/tasks/${id}`)
                        }}
                    />
                </div>
            </Container>
        </div>
    )
}

export default withNamespaces()(
    withRouter(
        EmployeeTaskDetail
    )
);
